<template>
    <ion-toolbar>
    </ion-toolbar>

    <div class="main_wrapper ion-padding">
        <div class="page_title">Add Email</div>
        <el-form class="full_page" :model="formsData.userForm" :rules="formsData.userForm.rules" :ref="el => formsData.userForm.ref = el" :label-position="'top'" @submit.prevent="goNext('userForm')">
            <el-form-item label="Email" prop="email" :required='true'>
                <el-input type="email" v-model="formsData.userForm.email.value" placeholder="email@gmail.com" @input="checkFormValidation('userForm', false);"></el-input>
            </el-form-item>
            <el-form-item class="button_submit mb0">
                <el-button class="submit" type="blue" @click="goNext('userForm')" :disabled="formsData.userForm.disabled">
                    Continue <i class="el-icon-right"></i>
                </el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
    import {
        onMounted,
        inject
    } from 'vue';

    import {
        IonToolbar,
    } from '@ionic/vue';

    import {
        addIcons
    } from 'ionicons'

    import {
        arrowBackOutline
    } from 'ionicons/icons'
    addIcons({
        'arrow-back-outline': arrowBackOutline
    })

    import {
        useStore
    } from 'vuex'
    import {
        useRouter,
    } from 'vue-router'
    import formHooks from '@/hooks/form/form'
    import formValidate from '@/hooks/form/validate/validate'

    export default {
        components: {
            IonToolbar,
        },
        setup() {
            const $store = useStore()
            const $router = useRouter()
            const setPageClassGlobal = inject('setPageClassGlobal');

            const userData = $store.getters.GET_USER_DATA;
            const email = userData.email;

            const formsDataArray = {
                userForm: {
                    email: {
                        value: email ? email : '',
                        validators: [{
                            validator: (rule, formField, callback) => {
                                formValidate.validate(rule, formField, 'email', callback, setFormValidation);
                            },
                            trigger: ['blur', 'enter']
                        }]
                    },
                }
            };

            const goBack = () => {
                $router.push({
                    name: 'welcome',
                })
            };

            const goNext = (formName) => {
                formsRefs[formName].value.validate((valid) => {
                    if (valid) {
                        $store.dispatch('SET_USER_DATA', getFormValues(formName));
                        $router.push({
                            name: 'auth_verify',
                        })
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            };

            onMounted(() => {
                setPageClassGlobal('global_auth_page');
                setFormRefs();
                formsRefs.userForm.value.$el[0].focus();
                checkFormValidation('userForm', false);
            });

            const {
                checkFormValidation,
                setFormValidation,
                getFormValues,
                setFormRefs,
                formsData,
                formsRefs,
            } = formHooks(formsDataArray);

            return {
                formsData,
                checkFormValidation,
                setFormValidation,
                goBack,
                goNext,
            }
        },
    }
</script>